// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__15lmP","footer":"Form_footer__uerxN"};